import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import { ScanPageLayout } from './layout';
import { ScanHeader } from './header';
import { AutoScaleProvider } from './auto-scale-provider';

export const Scan = ({ renderBody, shipmentNumber }) => (
  <AutoScaleProvider>
    <ScanPageLayout renderBody={renderBody} renderHeader={() => <ScanHeader shipmentNumber={shipmentNumber} />} />
    <ToastContainer hideProgressBar pauseOnHover position='bottom-right' transition={Slide} />
  </AutoScaleProvider>
);

Scan.propTypes = {
  renderBody: PropTypes.func.isRequired,
  shipmentNumber: PropTypes.string,
};
